import * as CONSTANTS from '@/lib/constants'

export default {
  install (Vue) {
    Vue.$CONSTANTS = CONSTANTS
    Vue.prototype.$CONSTANTS = CONSTANTS
  }
}
